
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Musician Competition </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm musical-comp section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Calling All<span > Musician Competition</span></h2>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>CALLING ALL MUSI<span class="small-sm">CIAN COMPETITION</span></h4>
                </div>
                <div class="fide-chess-text">
                    <p>Dare we say that music in classrooms can be fun? Indeed it is !Our extensive Music Competition is
                        designed to engage students with fun musical activities, build their confidence, and lead them
                        onto vocal exercises in musical styles they are familiar with.</p>
                </div>
                <p>
                    Music in all sense is a stress reliever, rejuvenation and a meditation itself. It can be in any
                    form, Vocal, Instrumental or any talent related to it classical or western. I Too Have a Talent is a
                    platform to explore the interests of the students and hunt the talents in them.
                </p>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/music-banner.jpg"
                        alt="GHRSCF">
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>
        <div class="text-center">
            <iframe src="https://urlzs.com/xa5Ys" height="600" width="800" class="iframe-sm"></iframe>
        </div>
    </div>
</section>
